module.exports = __webpack_public_path__ + "static/media/robot-choir-logo.6c0f3541.svg";